import { provideHttpClient } from '@angular/common/http';
import {ApplicationConfig, importProvidersFrom, isDevMode} from '@angular/core';
import {LuxonDateAdapter} from '@angular/material-luxon-adapter';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import {provideAnimations} from '@angular/platform-browser/animations';
import {PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading} from '@angular/router';
import {providePlatform} from '@platform';
import {appRoutes} from 'app/app.routes';
import {provideAuth} from 'app/core/auth/auth.provider';
import {provideIcons} from 'app/core/icons/icons.provider';

import {mockApiServices} from 'app/mock-api';
import {TranslocoHttpLoader} from "./core/transloco/transloco.http-loader";
import {provideTransloco} from "@ngneat/transloco";
import {NgApexchartsModule} from "ng-apexcharts";
import {provideToastr} from "ngx-toastr";
import {NgxIntlTelInputModule} from "ngx-intl-tel-input";
import {NgxGpAutocompleteModule} from "@angular-magic/ngx-gp-autocomplete";
import {Loader} from "@googlemaps/js-api-loader";
import {NgxMaterialTimepickerModule} from "ngx-material-timepicker";

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),
        provideHttpClient(),
        provideRouter(appRoutes,
            withPreloading(PreloadAllModules),
            withInMemoryScrolling({scrollPositionRestoration: 'enabled'}),
        ),

        // Material Date Adapter
        {
            provide: DateAdapter,
            useClass: LuxonDateAdapter,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'D',
                },
                display: {
                    dateInput: 'DDD',
                    monthYearLabel: 'LLL yyyy',
                    dateA11yLabel: 'DD',
                    monthYearA11yLabel: 'LLLL yyyy',
                },
            },
        },

        // Transloco Config
        provideTransloco({
            config: {
                availableLangs: ['en', 'es'],
                defaultLang: 'en',
                reRenderOnLangChange: true,
                prodMode: !isDevMode(),
            },
            loader: TranslocoHttpLoader
        }),

        // Platform
        provideAuth(),
        provideIcons(),
        providePlatform({
            mockApi: {
                delay: 0,
                services: mockApiServices,
            },
            platform: {
                layout: 'modern',
                scheme: 'light',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                },
                theme: 'theme-default',
                themes: [
                    {
                        id: 'theme-default',
                        name: 'Default',
                    },
                    {
                        id: 'theme-brand',
                        name: 'Brand',
                    },
                    {
                        id: 'theme-teal',
                        name: 'Teal',
                    },
                    {
                        id: 'theme-rose',
                        name: 'Rose',
                    },
                    {
                        id: 'theme-purple',
                        name: 'Purple',
                    },
                    {
                        id: 'theme-amber',
                        name: 'Amber',
                    },
                ],
            },
        }),
        provideToastr({
            preventDuplicates: true
        }),
        importProvidersFrom(
            NgxIntlTelInputModule,
            NgApexchartsModule,
            NgxGpAutocompleteModule,
            NgxMaterialTimepickerModule
        ),
        {
            provide: Loader,
            useValue: new Loader({
                apiKey: 'AIzaSyAEC8OA4DLnrexfGJjIz2T655HQeLOus9g',
                libraries: ['places']
            })
        }
    ],
};
